import Chip from 'shared/Chip'
import css from './projectSlots.module.css'
import { ReactComponent as TeamIcon } from 'assets/icons/team.svg'
import { useMemo } from 'react'
import { IProject, IProjectSlot, ProjectToSlot } from 'screens/Projects/projects.types'
import { useRecoilValue } from 'recoil'
import useIsJoinProjectPossible from 'screens/Projects/hooks/useIsJoinProjectPossible'
import authAtom from 'screens/Auth/auth.atom'
import selfTeamsAtom from 'screens/Auth/components/InitProvider/selfTeams.atom'
import useIsLeaveProjectPossible from 'screens/Projects/hooks/useIsLeaveProjectPossible'

interface IProps {
  project: Pick<IProject, 'id' | 'projectToTeams' | 'adminOnly' | 'slots' | 'eventId'>
  onClickSlot: (slotId: IProjectSlot['id']) => void
  onClickSlotDelete: (slotId: IProjectSlot['id']) => void
  loading?: boolean
  editing?: boolean
}

const ProjectSlots = (props: IProps) => {
  const user = useRecoilValue(authAtom).user

  const joinPossible = useIsJoinProjectPossible(props.project)
  const leavePossible = useIsLeaveProjectPossible(props.project)

  const projectHasPlace = props.project.slots.some((slot) => !slot.claimedBy)

  const selfTeams = useRecoilValue(selfTeamsAtom).items
  const activeTeam = selfTeams[0]

  const slots = useMemo(() => {
    if (!props.project.slots) return []

    const slots = props.project.slots

    if (user.isAdmin && props.editing) {
      return slots
    }

    if (!joinPossible) {
      return slots.filter((s) => !!s.claimedBy)
    }
    return slots
  }, [props.project.slots, user.isAdmin, props.editing])

  const defaultTitle = user.isAdmin && props.editing ? ' Изменить слот' : 'Присоединиться'

  const handleClickDelete = (slot: ProjectToSlot) => {
    if (activeTeam?.id === slot.claimedBy?.id && leavePossible) {
      return () => {
        props.onClickSlotDelete(slot.id)
      }
    }
  }

  const handleClick = (slot: ProjectToSlot) => {
    if ((joinPossible && !slot.claimedBy) || (user.isAdmin && props.editing)) return () => props.onClickSlot(slot.id)
  }

  return (
    <div className='flex-lines'>
      {!user.isAdmin && joinPossible && projectHasPlace && props.project.adminOnly && (
        <div>
          <p className='text--body-m text--alert'>Вступить в проект можно только через запрос к администраторам.</p>
        </div>
      )}
      {!user.isAdmin && !activeTeam && projectHasPlace && (
        <div>
          <p className='text--body-m text--alert'>
            Для присоединения к проекту создайте команду или вступите в уже существующую
          </p>
        </div>
      )}
      {!user.isAdmin && activeTeam && activeTeam.ownerId !== user.id && projectHasPlace && (
        <div>
          <p className='text--body-m text--alert'>Вступить в проект может только лидер вашей команды</p>
        </div>
      )}
      <div className={css.slotsWrapper}>
        {slots?.map((slot) => (
          <Chip
            key={slot?.id}
            label={props.editing && !slot.claimedBy ? slot?.title ?? '-' : slot.claimedBy?.name ?? defaultTitle}
            avatar={!!slot.claimedBy && <TeamIcon className={css.teamIcon} />}
            style={{ width: '236px' }}
            onClick={handleClick(slot)}
            onDelete={handleClickDelete(slot)}
            variant={slot.claimedBy ? 'active' : 'normal'}
            disabled={!slot.claimedBy && props.loading}
          />
        ))}
      </div>
    </div>
  )
}

export default ProjectSlots
